module.exports = __webpack_public_path__ + "static/jon-3628120f8db7b40592a445077f6b46c9.jpg";